import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';
import Bignumber from 'bignumber.js';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import objectSupport from 'dayjs/plugin/objectSupport';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const redirectUrl = window.location.hostname === 'localhost' ? 'http://localhost:4200' : environment.apiUrl;

Amplify.configure({
  ['Auth']: {
    ['Cognito']: {
      userPoolId: environment.oktaUserPoolId,
      userPoolClientId: environment.oktaUserPoolWebClientId,
      loginWith: {
        oauth: {
          domain: `${environment.oktaUserPoolDomain}.auth.${environment.region}.amazoncognito.com`,
          scopes: ['aws.cognito.signin.user.admin', 'openid', 'email'],
          redirectSignIn: [redirectUrl],
          redirectSignOut: [redirectUrl],
          responseType: 'code',
        },
      },
    },
  },
});

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.extend(objectSupport);
dayjs.extend(timezone);
dayjs.extend(utc);

Bignumber.config({ EXPONENTIAL_AT: 1000 }); // eslint-disable-line @typescript-eslint/naming-convention

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
